import React from 'react'

import { SaveStatuses } from '../../../../../store/modquiz/quiz_objects/quiz-object/save-statuses';

interface CardStatusProps {
    status: SaveStatuses
}
function CardStatus({status}: CardStatusProps) {
    return (
        <div className={`card-status ` + status}>
            
        </div>
    )
}

export default CardStatus

